import React, { useEffect, useState } from "react";
import BottomSheet from "../ButtomSheet/BottomSheet";
import { useTranslation } from "react-i18next";
import orderServices from "../../api-service/order-service";
import { toast } from "react-toastify";

function OptSend(props: any) {
  const { t } = useTranslation();
  const [otp, setOtp] = useState("");
  const [resendTimer, setResendTimer] = useState(60);
  useEffect(() => {
    const timer = setInterval(() => {
      setResendTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const handleOtpChange = (e: any) => setOtp(e.target.value);
  const handleResend = () => {
    if (resendTimer === 0) {
      setResendTimer(60);
    }
  };

  const sendOtp = () => {
    orderServices
      .sendOtp({
        phone: props.phone,
        otp_code: otp,
        name: props.name,
        branch_id: props.branch_id,
      })
      .then((res) => {
        localStorage.setItem(
          "tokenOrder" + props.branch_id,
          res.data.data.token
        );
        orderServices
          .storeOrder({
            token: res.data.data.token,
            items: props.cartItems,
            note: props.note,
            table_id: 1,
          })
          .then((res) => {
            toast.success(
              `${t("gloabl.orderSuccess")} # ${res.data.data.order_id}`
            );
          })
          .catch((err) =>
            toast.error(t("gloabl.orderError"), {
              bodyClassName: "rounded-lg",
              className: "bg-red-500 text-white rounded-lg shadow-lg",
              hideProgressBar: true,
            })
          );
        setOtp("");
        localStorage.removeItem("cart" + props.branch_id);
        props.loadCart();
        props.setPhone("");
        props.setName("");
        props.setNote("");
        props.setOpenOptSheet(false);
      })
      .catch((err) => {
        // console.log(err);
        setOtp("");
        props.setOpenOptSheet(false);
        if (err.status === 422) {
          toast.error(t("gloabl.Invalid"), {
            className: "bg-red-500 text-white rounded-lg shadow-lg",
            hideProgressBar: true,
          });
        }
      });
  };
  return (
    <BottomSheet
      toggleOpen={(value) => props.setOpenOptSheet(value)}
      title={t("gloabl.otp")}
      open={props.openOptSheet}
    >
      <div className="flex gap-4 md:gap-5 flex-col items-center justify-center p-6 md:p-8">
        <h2 className="text-lg md:text-xl font-semibold text-foreground text-center">
          {t("gloabl.verification")} {props.phone}
        </h2>
        <input
          type="text"
          value={otp}
          onChange={handleOtpChange}
          maxLength={6}
          placeholder="Enter OTP"
          className="w-full px-4 py-3 md:py-4 border-2 border-border rounded-lg text-center text-xl md:text-2xl font-semibold bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-300"
        />

        <button
          disabled={otp.length < 6}
          onClick={sendOtp}
          className={`w-full px-6 py-3 rounded-lg font-semibold text-base md:text-lg transition-all duration-300 ${
            otp.length < 6
              ? "bg-muted text-muted-foreground cursor-not-allowed"
              : "bg-primary text-onPrimary hover:bg-primary/90 shadow-md hover:shadow-lg"
          }`}
        >
          {t("gloabl.send")}
        </button>
        <button
          onClick={handleResend}
          disabled={resendTimer > 0}
          className={`w-full px-6 py-3 rounded-lg font-semibold text-base md:text-lg transition-all duration-300 ${
            resendTimer > 0
              ? "bg-muted text-muted-foreground cursor-not-allowed"
              : "bg-primary text-onPrimary hover:bg-primary/90 shadow-md hover:shadow-lg"
          }`}
        >
          {resendTimer > 0
            ? `${t("gloabl.resend")} ${t("gloabl.otp")} ${t("gloabl.in")} ${resendTimer}${t("gloabl.s")}`
            : `${t("gloabl.resend")} ${t("gloabl.otp")}`}
        </button>
      </div>
    </BottomSheet>
  );
}

export default OptSend;
